import { Box, CircularProgress } from '@mui/material';
import React from 'react';

const GridLoader = () => (
  <Box
    display="flex"
    justifyContent="center"
    alignItems="center"
    position="absolute"
    top={0}
    left={0}
    width="100%"
    height="100%"
    bgcolor="background.paper" // Semi-transparent background
    zIndex={10}
    fontSize="12px"
    color="#666"
  >
    <Box display="flex" flexDirection="column" alignItems="center">
      <CircularProgress color="inherit" size={24} />
      <Box mt={2}>Loading...</Box>
    </Box>
  </Box>
);

export default GridLoader;
